import { UTableColumn, UTable } from 'umy-ui';
import locale from 'umy-ui/lib/locale';
import lang from 'umy-ui/lib/locale/lang/en';
import Vue from 'vue';

locale.use(lang);

Vue.use(UTableColumn);
Vue.use(UTable);
